import http from "../httpService";

const apiEndpoint = "/sys";

export function getQueueWorkReportLine() {

  return http.get(apiEndpoint + '/queue/workReportLine')
}